<div class="card-body mt-0 py-5 px-5">
    <div class="row mb-5">
        <div class="col mb-lg-0 mb-4 form-group"> 
            <select class="form-control" id="_snoteType" name="_snote_type" [(ngModel)]="snote_type">
                <option value="0">All Notes</option>
                <option *ngFor="let item of clientService.client_note_type" [value]="item.note_type">
                    {{ item.type_desc }}
                </option> 
            </select>
        </div> 
        <div class="col mb-lg-0 mb-4 form-group"> 
            <input type="date" class="form-control" placeholder="Begin" name="_snote_startDate" [(ngModel)]="snote_startDate">

        </div>
        <div class="col mb-lg-0 mb-4 form-group"> 
            <input type="date" class="form-control" placeholder="End" name="_snote_endDate" [(ngModel)]="snote_endDate">
        </div>
        <div class="col mb-lg-0 mb-4 form-group">
            <label>.</label>
            <button class="btn btn-success font-weight-bold mr-2" (click)="search_click()">
            <i class="las la-search"></i> Search
            </button>
        </div>

    </div>
    <div class="card-footer  d-flex justify-content-between px-0 py-3">
        <div>
            <button type="button" class="btn font-weight-bold btn-sm btn-primary mr-2" (click)="add()"> 
                <i class="fas fa-plus icon-sm"></i>Add Note
            </button>
        </div>  
    </div>

    <div class="table-responsive max-h-500px">
        <table class="table table-bordered table-sm rounded">
            <thead class="thead-light">
                <tr>
                     <td>Note Text</td>
                     <td>Note Type</td>
                     <td>Date</td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of clientService.client_notes">
                    <td>{{ item.note_text }}</td>
                    <td style="white-space: nowrap;">{{ getNoteTypeDesc(item.note_type) }}</td>
                    <td style="white-space: nowrap;">{{ item.note_date }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="saveNoteModal" tabindex="-1" role="dialog" aria-labelledby="saveNoteModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="saveNoteModalLabel">Save Client Note</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <label for="noteText">Note Text:</label> 
                    <textarea class="form-control" name="noteText" rows="4" [(ngModel)]="newNote.note_text"></textarea>
                </div>
                <div class="form-group">
                    <label for="noteType">Note Type:</label>
                    <select class="form-control" id="noteType" [(ngModel)]="newNote.note_type">
                        <option value="0">Select Note Type</option>
                        <option *ngFor="let item of clientService.client_note_type" [value]="item.note_type">
                            {{ item.type_desc }}
                        </option> 
                    </select>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="saveNote()">Save</button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
